<template>

<div>
    <b-row class="align-items-center justify-content-center mobfontsize">
        <h5 style="border-bottom: 2px solid #2a5d77; padding: 8px; margin-bottom: 1rem">
            {{$ml.get('generalset')}}
            <b-icon class="ml-2" icon="sliders" />
        </h5>
    </b-row>

    <!-- Top of the page -->

    <b-row class="plan1 align-items-center justify-content-center bg-msstream small marginrl mobfontsize cardGenSet">
        <b-col cols="6 col-md-3 col-xl-1" class="cardGSL">
        </b-col>       
        <b-col cols="6 col-md-3 col-xl-2" class="cardGSC">
            <b-row class="titleGS">{{$ml.get('sortBy')}}</b-row>
            <b-row class="elementinCardGS pt-0 pb-0 ">
                <b-form-select class="bformSelSm" v-model="sortBy" :options="sortByOptions" v-on:input="getTop10()" ></b-form-select>
            </b-row>
        </b-col>
        <b-col cols="6 col-md-3 col-xl-2" class="cardGSC">
            <b-row class="titleGS">{{$ml.get('sortOn')}}</b-row>
            <b-row class="elementinCardGS pt-0 pb-0">
                <b-form-select class="bformSelSm" v-model="sortOn" :options="sortOnOptions" @change=getTop10></b-form-select>
            </b-row>
        </b-col>     

        <!-- Calendar / Period -->
        <b-col cols="12 col-xl-4" class="cardGSR">
            <b-row class="titleGS justify-content-center">{{$ml.get('period')}}</b-row>
            <b-row class="elementinCardGS justify-content-center p-0" style="background-color: transparent">
                <date-picker v-model="range" @input="calendarValidate = true" is-range is24hr mode="dateTime" :timezone="''" >
                    <template v-slot="{ inputEvents }">
                        <b-row style="min-width:350px">
                            <b-button style="font-size:small; border-top-right-radius:0px !important; border-bottom-right-radius:0px !important" variant="quanteeclg" v-on="inputEvents.start">
                                <font-awesome-icon :icon="['fas', 'calendar-week']"></font-awesome-icon>&nbsp;
                                {{dateStart}} - {{dateEnd}}
                            </b-button>
                            <b-button style="font-size:small; border-top-left-radius:0px !important; border-bottom-left-radius:0px !important" variant="quanteeclg" v-if="calendarValidate" @click="timeRangeType=true, adjustDate(), getTop10(), dateLabel='custom'" >
                                <font-awesome-icon style="color:green" :icon="['fas', 'check']"></font-awesome-icon>
                            </b-button>
                            <b-button style="font-size:small; border-top-left-radius:0px !important; border-bottom-left-radius:0px !important" variant="quanteeclg" v-else disabled>
                                <font-awesome-icon style="color:green" :icon="['fas', 'check']"></font-awesome-icon>
                            </b-button>
                        </b-row>
                    </template>
                </date-picker>
            </b-row>
        </b-col>        
    </b-row>



    <b-row class="align-items-center justify-content-center marginrl small mobfontsize" >

        <b-col cols="12" class="cardGraphs backOffload padGMob">
            <b-row class="titleGS">
                <h6 style="margin:0px">
                    
                        {{$ml.get('ranking')}}
                </h6>
            </b-row>

            <b-row v-if="isLoading" class="align-items-center backTable justify-content-center marginrl small mobfontsize" >
                <b-spinner label="Loading..."></b-spinner>
            </b-row>

            <b-row   v-if="!isLoading"  class="backTable">
                <b-table responsive striped :items="rankingTable" :fields="rankingFields">
                    <template v-slot:cell(video_ID)="{ item }">
                        {{item.video_ID}}
                        &nbsp;
                            <b-btn size="sm" variant="db-sb" @click="goToVideoList(item)" title="Go to video list page with this video id" >
                            <b-icon icon="play-btn" /> 
                        </b-btn> 
                    </template>

                    <template v-slot:cell(actions)="{ item }">
                            <b-btn size="sm" variant="db-sb" @click="goToAnalytics(item)" title="Go to video analytics page on this video" >
                            <b-icon icon="graph-up" />
                        </b-btn> 
                    </template>
                </b-table>
            </b-row>


        </b-col>
    </b-row>



</div>

</template>

<script>
import AnalyticsService from "@/services/analytics.service";
import DatePicker from 'v-calendar/lib/components/date-picker.umd';

var analyticsService = new AnalyticsService();
let myDateBegin = new Date();
let moment = require("moment");

export default {
  components: {
    DatePicker
  },
  props: [    
  ],
  data () {
    return {
        clientView: (this.$auth.getMyUser().roles.indexOf('admin') > -1) ? this.$auth.getMyClientView() || this.$auth.getMyUser().client : this.$auth.getMyUser().client,
        sortBy:"video_id",
        sortOn:"max_viewers",
        startDate:"now-7d",
        endDate:"now",
        rankSize: 50,

        isLoading:true,

        rankingTable:[],
        rankingFields: [
            { key: "ranking", label: "Ranking", sortable: true, thClass: 'text-center', tdClass: 'align-middle' },
            { key: "video_ID", label: "video ID", thClass: 'text-center', tdClass: 'align-middle' },
            { key: "maximum_viewers", label: "Maximum Viewers", thClass: 'text-center', tdClass: 'align-middle' },
            //{ key: "isEditor", label: "Videos Manager", thClass: 'text-center', tdClass: 'align-middle' },
            { key: "offload_percent", label: "Offload Percent", thClass: 'text-center', tdClass: 'align-middle' },
            { key: "data_downloaded_in_P2P", label: "Data Downloaded In P2P", thClass: 'text-center', tdClass: 'align-middle' },
            { key: "data_downloaded_from_CDN", label: "Data Downloaded From CDN", thClass: 'text-center', tdClass: 'align-middle' },
            { key: "total_data_downloaded", label: "Total Data Downloaded", thClass: 'text-center', tdClass: 'align-middle' },
            { key: "actions", label: "Go to analytics page", thClass: 'text-center', tdClass: 'align-middle' },
        ],

        dateStart: '',
        dateEnd: '',
        range: {
            end: new Date(),
            start: new Date(myDateBegin.getFullYear(),  myDateBegin.getMonth(), myDateBegin.getDate() - 7, myDateBegin.getHours(), 0, 0),
            dispEnd: '1',
            dispStart: '1',
        },
        calendarValidate: false, 

        sortByOptions: [
            {text:"Video ID", value:"video_id"},
            //{text: "Site ECDN", value: "ecdnSite"}
        ],
        sortOnOptions: [
            {text: "Maximum Viewers", value:"max_viewers"},
            {text: "Offload Percent", value:"offload_percent"},
            {text: "Data downloaded in P2P", value:"MB_peer"},
            {text: "Data downloaded from CDN", value:"MB_server"},
            {text: "Total data downloaded", value:"MB_total"},

        ]
        
    }
  },
  mounted () {
    this.getTop10();
  },
  created () {
  },
  computed: {
  },
  methods: {

    getTop10()
    {
        this.classicDate();
        this.isLoading = true;
        analyticsService.getTop10(this.clientView, this.sortBy, this.sortOn, this.startDate, this.endDate, this.rankSize, this.$auth.token()).then(response=>{
            console.log(response)
            this.rankingTable = [];
            response.forEach((element, index) => {
                let object = {
                    ranking:index+1,
                    video_ID: element.key,
                    maximum_viewers: element.max_viewers.value,
                    offload_percent: Number(element.offload_percent.value).toFixed(2) + "%",
                    data_downloaded_in_P2P: this.display_MB(element.MB_peer.value),
                    data_downloaded_from_CDN: this.display_MB(element.MB_server.value),
                    total_data_downloaded: this.display_MB(element.MB_total.value),
                }

                this.rankingTable.push(object);
            });
            this.isLoading = false;
        })
    },
    classicDate() {

        this.startDate = this.range.start;
        this.endDate = this.range.end;
        this.dateEnd = moment(this.range.end).format("DD/MM/YY @HH:mm:ss");
        this.dateStart = moment(this.range.start).format("DD/MM/YY @HH:mm:ss");
    },
    adjustDate() {
        /*this.range.end = new Date(1646057700000);
        this.range.start = new Date(1646055900000);*/
        this.startDate = this.range.start;
        this.endDate = this.range.end;
        this.dateEnd = moment(this.range.end).format("DD/MM/YY @HH:mm:ss");
        this.dateStart = moment(this.range.start).format("DD/MM/YY @HH:mm:ss");
    },

    display_MB(value) {
        let label = [];
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        return value + " "+ unit;
    },

    goToAnalytics(item)
    {
        console.log(item)
        this.$router.push('/analytics?video=' + item.video_ID + '&title=videoconfig');

    },

    goToVideoList(item)
    {
        let searchParameters = {};
        searchParameters["$and"] = [];
        var objTest = { $regex: "(?i)^.*" + item.video_ID + ".*" };

        searchParameters["$and"].push({
              $or: [{ videoID: objTest }/*, { tags: objTest }*/],
        });
        

        try {
            let searchStorage = sessionStorage;
            searchStorage.setItem(
            "QuanteecLabs_searchparameters",
            JSON.stringify(searchParameters)
            );
            searchStorage.setItem(
            "QuanteecLabs_searchkey", ""
            );
            searchStorage.setItem("QuanteecLabs_searchbar", item.video_ID);
            this.$router.push('/videosplugin');

        } catch (err) {}
    }

  },
  watch: {
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.centered {
    text-align: center;
}

.rightered {
    text-align: right;
}

.scrollmenu {
  display: flex;
  justify-content: space-between;
  overflow: auto;
  white-space: nowrap;
}
@media print {
    .noprint {
        display: none;
    }
    .printefficiency {
        margin-top: 200px;
    }
    .printenergy {
        margin-top: 400px;
    }
    .printviews {
        margin-top: 350px;
    }
}
.oldcard {
    box-shadow: rgba(#14BF98, 0.17) 2px 4px 14px, rgba(#14BF98, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: #fbfbfb !important;
    border-radius: 5px !important;
    border: 0.15rem solid #14BF98 !important;
//    background-color: rgba(109,236,142,0.517647); //green
    &:hover {
      box-shadow: rgba(#14BF98, 0.3) 4px 8px 20px, rgba(#14BF98, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}

.spaceUnit {
    margin-left: 1px;
}

.logoEn {
    max-width: 23px;
    padding: 2px;
    margin-right: 5px;
    max-height: 23px;
}

.row1st {
    font-size:small; 
    background-color:#dfe5ec;
    margin: 3rem 0rem 0rem;
    padding-top: 2.3rem;
    padding-bottom: 2.3rem;
    align-items: center;
    justify-content: space-around;
    border-top: 1px solid #2a5d77;
    border-left: 1px solid #2a5d77;
    border-right: 1px solid #2a5d77;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.rowStats {
    justify-content: space-around;
    align-items: center;
    margin: 0rem;
    padding: 2rem 0rem;
    border-top: 1px solid #dfe5ec;
}

.rowDetailStats {
    align-items: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
    transition: 0.3s;
    &:hover {
        box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
        transform: scale(1.03);
        cursor: pointer;
    }
}

.cardGSL {
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    padding: 1rem 1rem 0.5rem 1rem;
    margin: 0;
}

.cardGSC {
    padding: 1rem 1rem 0.5rem 1rem;
    margin: 0;
}
.cardGSR {
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
    padding: 1rem 1rem 0.5rem 1rem;
    margin: 0;
}

.gDotSeparator {
    border-bottom: 1px dotted darkblue; 
    margin:0px 4rem;
}

.gDashSeparator {
    border-top: 1px dashed darkblue; 
}

.toolong {
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  max-width: 250px;
}

.toolong215 {
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  max-width: 215px;
}

.bformSelSm {
    font-size: small; 
    border: 1px solid transparent; 
    margin: 0rem;
    &:hover {
        cursor: pointer;
        color: #048F94;
        border-color: #048F94;
    }
}

.elementinCardGS {
    background-color: white;
    border-color: #d6dce2 !important;
    border-radius: 5px;
    padding: 0.5rem 0rem;
    margin: 0.5rem;
    font-size: small;
}

.cardGenSet {
    border-radius:5px;
    box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
}

.cardGraphs {
    background-color: #F2F2F2;
    padding: 1rem;
    margin: 0.25rem;
    border-radius: 10px;
    border: 1px solid #d6dce2;
    transition: .15s all ease-in-out;
    box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
}

.cardRow {
    background-color: #F2F2F2;
    padding: 1rem;
    margin: 0.25rem;
    border-radius: 10px;
    border: 1px solid #d6dce2;
    transition: .15s all ease-in-out;
    box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
    &:hover {
      transform: scale(1.03);
    }
}
.cardRow2 {
    background-color: #F2F2F2;
    padding: 1rem;
    margin: 0.25rem;
    border-radius: 10px;
    border: 1px solid #d6dce2;
    transition: .15s all ease-in-out;
    box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
    &:hover {
      transform: scale(1.03);
    }
}
.cardColL {
    background-color: #F2F2F2;
    padding: 1rem;
    margin: 0.125rem 0rem;
    border-radius: 10px;
    border: 1px solid #d6dce2;
    max-width: 49%;
    transition: .15s all ease-in-out;
    box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
    &:hover {
      transform: scale(1.03);
    }
}
.cardColR {
    background-color: #F2F2F2;
    padding: 1rem;
    margin: 0.125rem 0rem;
    border-radius: 10px;
    border: 1px solid #d6dce2;
    max-width: 49%;
    transition: .15s all ease-in-out;
    box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
    &:hover {
      transform: scale(1.03);
    }
}
.cardColC {
    background-color: #F2F2F2;
    padding: 1rem;
    margin: 0.25rem 0rem 0rem;
    border-radius: 10px;
    border: 1px solid white;
    max-width: 49%;
    max-height: 312.4px;
    transition: .15s all ease-in-out;
    box-shadow: rgba(#5a8ca4, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
    &:hover {
      transform: scale(1.03);
    }
}

.logoQDB {
    margin-right: 5px;
    max-height: 19px;
}
.backTable {
    background-color: #fff;
}
.backOffload {
    background-color: #2a5d77;
}
.backEnergy {
    background-color: #14BF98;
}
.backQuality {
    background-color: #2F90B0;
}
.backViews {
    background-color: #0f182f;
}

.statsPCol {
    background-color: white;
    border-color: #F2F2F2 !important;
    border-radius: 10px;
    padding: 1rem;
    margin: 1rem 0rem 0rem 0rem;
    min-height: 100px;
}
.statsPColC {
    background-color: white;
    border-color: #F2F2F2 !important;
    border-radius: 10px;
    margin: 1rem 0rem 0rem 0rem;
    padding: 5rem 1rem;
    height: 246px;
}

.statsP {
    background-color: white;
    border-color: #F2F2F2 !important;
    border-radius: 10px;
    padding: 1rem;
    margin: 1rem 0rem 0rem 0rem;
}
.statsP3 {
    background-color: white;
    border-color: #F2F2F2 !important;
    border-radius: 10px;
    padding: 2rem 10rem;
    margin: 1rem 0rem 0rem 0rem;
}


.btn-emptyBA {
  color: #2a5d77  !important;
  font-size:small;
  background-color: #FBFCFC !important;
  border-radius: 0.25rem !important;
  border: 0.1rem solid transparent !important;
  transition: .15s all ease-in-out;
  min-width: 350px;
  &:hover {
    cursor: pointer;
    color: #048F94;
    border-color: #048F94;
  }
}

.rowBA {
    justify-content: space-between;
    align-items: center;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    &:hover {
        cursor: pointer;
        color: #048F94;
        border-color: #048F94;
    }    
}

@media (max-width: 920px) {
    .marginrl {
        margin-right: -10px;
        margin-left: -10px;
    }
    .mobfontsize {
        font-size:11px;
    }
    .padGMob {
        padding: 1rem 0.25rem;
    }
    .noprint {
        font-size: 12px;
    }
}

@media (min-width: 920px) {
    .marginrl {
    margin-right: 0.75rem;
    margin-left: 0.75rem;
    }
}

.titleGS {
    margin-left:0rem;
    margin-right:0rem;
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;
}

.titleDashBD {
    margin: 0rem;
    justify-content: space-between;
    align-items: center;
    color: white;
}

.checkIcon {
    background-color:white; 
    border: 1px solid #001621; 
    cursor: pointer;
    transition: .15s all ease-in-out;
    &:hover {
    color:#048F94;
    border: 1px solid #048F94; 
    }
}

.badge{
  font-weight: 400;
  color: #2a5d77;
  padding: 4px;
  width: 100px;
  background-color: white;
  text-decoration: none;
}

.badgeClicked{
  font-weight: 400;
  padding: 4px;
  color: #2a5d77;
  border: 1px solid #2a5d77;
  background-color: #FBFCFC !important;
  box-shadow: rgba(#2a5d77, 0.3) 1px 2px 3px, rgba(#2a5d77, 0.3) 1px 2px 3px;
  &:hover {
    border: 1px solid transparent;
    color:white;
    background-color: #9FA6B2 !important;    
    text-decoration: none;
  }
}

.plan1 {
    z-index: 1 !important;
    position: relative;
}

.bold {
    font-weight: bold;
}

.white {
  color: white;
}
.blueV {
  color: #2F90B0;
}
.darkblue {
  color: #2a5d77;
}
.green {
    color: #14BF98;
}
.black {
    color: #0f182f;
}

.collection-linked {
  border: 1px dashed #14BF98;
  border-radius: 2px;
  padding: 5px;
  text-align: center;
}

.tagnotselected { 
  border: 1px solid #2a5d77 !important;
  cursor: pointer;
  border-radius: 8px;
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  align-items: center;
  text-align: center;
  margin-right: 3px;
  padding: 7px 10px;
  background-color: #2a5d77;
  color: white;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  &:hover {
    color: #2a5d77 !important;
    background-color: white !important;
  }
  
}

.tagselected {
  cursor: pointer;
  border: 1px solid #14BF98 !important;
  border-radius: 8px;
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  text-align: center;
  margin-right: 3px;
  padding: 7px 10px;
  background-color: #14BF98;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  color: white;
  &:hover {
    color: #14BF98 !important;
    background-color: white !important;
  }
}

.checkBVSel {
    position: fixed;
    top: -1%;
    right: 0%;
}

.myBtn {
  position: fixed; /* Fixed/sticky position */
  bottom: 1px; /* Place the button at the bottom of the page */
  right: 1px; /* Place the button 30px from the right */
  z-index: 99; /* Make sure it does not overlap */
  border: none;
  color: #2a5d77;
  outline: none; /* Remove outline */
  cursor: pointer; /* Add a mouse pointer on hover */
  padding: 5px; /* Some padding */
    &:hover {
        color: #14BF98;
    }
}

</style>